import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { KnowledgeBaseArticleLinkModule } from '@app/pipes/knowledge-base-article-link.module';
import { getAccount } from '@app/reducers/account/account-service.selectors';
import { getAuthenticatedUser } from '@app/reducers/orm/employee/employee.selectors';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { DialogActivationComponent, DialogRef } from '@sb/ui/dialog';
import { take } from 'rxjs';

import { OnboardingChapterModule } from '../components/chapter.module';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'schedule-shift-dialog',
  imports: [
    DialogActivationComponent,
    FormsModule,
    NgStyle,
    TranslatePipe,
    OnboardingChapterModule,
    KnowledgeBaseArticleLinkModule,
  ],
  templateUrl: './schedule-shift-dialog.component.html',
})
export class ScheduleShiftDialogComponent {
  private dialogRef = inject(DialogRef);
  private store = inject<Store<AppState>>(Store);

  userName: string;
  companyName: string;

  constructor() {
    void this.store
      .select(getAuthenticatedUser)
      .pipe(take(1))
      .subscribe((user) => (this.userName = user.first_name));

    void this.store
      .select(getAccount)
      .pipe(take(1))
      .subscribe((account) => (this.companyName = account.company));
  }

  close(result: OnboardingDialogResult) {
    this.dialogRef.close(result);
  }
}
